import { createEventDefinition } from 'ts-bus'

export const saveMapViewState = createEventDefinition()('map.viewState.saved')

export const toggleMainNav = createEventDefinition()('main.nav.toggle')
